import { render, staticRenderFns } from "./algo-task-four.html?vue&type=template&id=fa79faca&scoped=true&"
import script from "./algo-task-four.js?vue&type=script&lang=js&"
export * from "./algo-task-four.js?vue&type=script&lang=js&"
import style0 from "./algo-task-four.scss?vue&type=style&index=0&id=fa79faca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa79faca",
  null
  
)

export default component.exports